<template>
    <div>
        <h1>Update User Information</h1>
        <div v-if="!isNameUpdate">
            <div class="card">
                <div class="card-header">Name</div>
                <div class="card-body">
                    <b-row>
                        <b-col cols="4"><span class="font-weight-bold">Last Name: </span>{{application.lastName}}</b-col>
                        <b-col cols="3"><span class="font-weight-bold">First Name: </span>{{application.firstName}}</b-col>
                        <b-col cols="3"><span class="font-weight-bold">Middle Name: </span>{{application.middleName}}</b-col>
                        <b-col cols="2" rowspan="2">
                            <b-button type="button" variant="secondary" role="button" class="mr-1" @click="toggleUpdate('n')">Update Name</b-button>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>
        <div v-if="isNameUpdate">
            <NameUpdate :application="application" @on-validate="mergeAndToggle"></NameUpdate>
        </div>
        <div v-if="!isSsnUpdate">
            <div class="card">
                <div class="card-header">Social Security Number</div>
                <div class="card-body">
                    <b-row>
                        <b-col cols="5"><span class="font-weight-bold">Social Security Number: </span>{{application.license.socialSecurityNumber}}</b-col>
                        <b-col cols="2" rowspan="2">
                            <b-button type="button" variant="secondary" role="button" class="mr-1" @click="toggleUpdate('s')">Update SSN</b-button>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>
        <div v-if="isSsnUpdate">
            <SsnUpdate :application="application" @on-validate="mergeAndToggle"></SsnUpdate>
        </div>
        <div v-if="!isDOBUpdate">
            <div class="card">
                <div class="card-header">Date of Birth</div>
                <div class="card-body">
                    <b-row>
                        <b-col cols="5"><span class="font-weight-bold">Date of Birth: </span>{{application.license.dateOfBirth}}</b-col>
                        <b-col cols="2" rowspan="2">
                            <b-button type="button" variant="secondary" role="button" class="mr-1" @click="toggleUpdate('d')">Update Date of Birth</b-button>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>
        <div v-if="isDOBUpdate">
            <DOBUpdate :application="application" @on-validate="mergeAndToggle"></DOBUpdate>
        </div>
        <div v-if="!isEmailUpdate">
            <div class="card-header">Email Address (updates Keycloak username)</div>
            <div class="card-body">
                <b-col cols="5"><span class="font-weight-bold">Email Address:</span>{{application.emailAddress}}</b-col>
                <b-col cols="2" rowspan="2">
                    <b-button type="button" variant="secondary" role="button" class="mr-1" @click="toggleUpdate('e')">Update Email</b-button>
                </b-col>
            </div>
        </div>
        <div v-if="isEmailUpdate">
            <EmailUpdate :application="application" @on-validate="mergeAndToggle"></EmailUpdate>
        </div>
    </div>
</template>
<script>
    import NameUpdate from '@/components/info-update/NameUpdate.vue'
    import SsnUpdate from '@/components/info-update/SsnUpdate.vue'
    import DOBUpdate from '@/components/info-update/DOBUpdate.vue'
    import EmailUpdate from '@/components/info-update/EmailUpdate'
    import axios from "axios"
    import axiosRetry from 'axios-retry'
    import { required, minLength, maxLength, email } from 'vuelidate/lib/validators'

    axiosRetry(axios, { retries: 3,
        retryDelay: axiosRetry.exponentialDelay  })

    export default {
        data() {
            return {
                application: {},
                isSsnUpdate: false,
                isNameUpdate: false,
                isDOBUpdate: false,
                isEmailUpdate: false
            }
        },

        methods: {
            loadApplication(id) {
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/application/latest/${id}`)
                    .then(response => {
                        this.application =  response.data
                        this.application.license.licenseType = response.data.license.licenseType.code
                        this.application.applyMethod = response.data.applyMethod.code
                        this.application.mnSupervisor = null
                        this.application.prevMnSupervisor = null
                    })
            },
            mergeAndToggle(section, model, isValid) {
                if (isValid) {
                    this.application = Object.assign({}, this.application, this.$data)
                    this.toggleUpdate(section)
                }
            },
            toggleUpdate(section) {
                switch(section) {
                    case 's':
                        this.isSsnUpdate = !this.isSsnUpdate
                        break
                    case 'n':
                        this.isNameUpdate = !this.isNameUpdate
                        break
                    case 'd':
                        this.isDOBUpdate = !this.isDOBUpdate
                        break
                    case 'e':
                        this.isEmailUpdate = !this.isEmailUpdate
                        break
                }
            }
        },
        created() {
            document.title = "Update User Information - Body Art"
            this.loadApplication(this.$route.params.id)
        },
        components: {
            NameUpdate,
            SsnUpdate,
            DOBUpdate,
            EmailUpdate,
        },
    }
</script>